/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateParentResultViewConfigRequest } from '../models/CreateParentResultViewConfigRequest';
import type { ParentResultViewConfigDto } from '../models/ParentResultViewConfigDto';
import type { UpdateParentResultViewConfigRequest } from '../models/UpdateParentResultViewConfigRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParentResultViewConfigControllerService {
  /**
   * createResultViewConfig
   * @returns ParentResultViewConfigDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createResultViewConfigUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateParentResultViewConfigRequest;
  }): CancelablePromise<ParentResultViewConfigDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/parent-result-view',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateResultViewConfig
   * @returns ParentResultViewConfigDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateResultViewConfigUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateParentResultViewConfigRequest;
  }): CancelablePromise<ParentResultViewConfigDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/parent-result-view',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * findByTerm
   * @returns ParentResultViewConfigDto OK
   * @throws ApiError
   */
  public static findByTermUsingGet({
    termId,
  }: {
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<ParentResultViewConfigDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/parent-result-view/{termId}',
      path: {
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
